export const ACCEPT_FORMATS = ['image/png', 'image/jpeg'];
export const MAX_SIZE = 1000000;

export enum ViewTypes {
  IMG,
  UUID,
}